<template>
  <div>
    <div v-if="!basicsLoaded" class="pt-2">
      <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
    </div>
    <b-container v-else fluid>
      <b-row v-if="configurationList.length === 0">
        <b-col>
          <div class="font-italic pb-3">{{cart.descEmpty}}</div>
        </b-col>
      </b-row>
      <b-table-simple v-else stacked="md">
        <b-thead>
          <b-tr>
            <b-th class="text-uppercase kub-no-border kub-color">{{cart.table.headings.article}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.quantity}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.unitPrice}}</b-th>
            <b-th class="text-uppercase kub-no-border kub-color text-right">{{cart.table.headings.sumPrice}}</b-th>
            <b-th class="text-uppercase kub-no-border"></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(configuration, index) in configurationList" :key="index">
            <b-td :class="{'kub-border-top': !md}">
              <b-card no-body class="overflow-hidden kub-no-border">
                <b-row no-gutters>
                  <b-col cols="12" sm="3" md="4" lg="3" xl="2">
                    <div class="d-inline-block">
                      <svg class="kub-cart-img" height="500" width="500" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                        <component :is="configuration.form.img" :material="configuration.material" :rand="configuration.rand"></component>
                      </svg>
                    </div>
                    <div class="float-right h-100 d-flex align-items-center d-sm-none">
                      <a @click="removeConfig(index)" style="cursor:pointer;">
                        <b-icon-trash class="kub-color-red" v-b-tooltip.hover :title="cart.tipDelete"></b-icon-trash>
                      </a>
                    </div>
                  </b-col>
                  <b-col cols="12" sm="8" md="8" lg="9" xl="10">
                    <b-card-body :class="[{'pt-0': true}, {'pr-0': true}, {'pb-0': true}, {'p-0': xs}]">
                      <b-card-text>
                        <b-container fluid>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.form}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.form.type}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.size}}</b-col>
                            <b-col cols="12" xl="10">
                              <ul class="p-0 m-0" style="list-style:none;">
                                <li v-for="(side, sideName, index) in configuration.form.size" :key="index">
                                  {{(sideName === sides[3] && (configuration.form.type === 'Kreis' || configuration.form.type === 'Halbkreis') ) ? 'Durchmesser' : (sideName === sides[4] ? 'Höhe' : 'Grundseite')}} {{sideName}}: {{side}} cm
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.material}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.material.type}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.color}}</b-col>
                            <b-col cols="12" xl="10">{{configuration.material.color.color}}</b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.rand}}</b-col>
                            <b-col cols="12" xl="10">
                              <ul class="p-0 m-0" style="list-style:none;">
                                <li v-for="(side, sideName, index) in configuration.rand" :key="index">
                                  {{sideName}}:
                                  <span v-for="(char, charName, index) in side" :key="index">{{char}}
                                    <span v-if="charName === 'oesenAnzahl'"> Stück </span>
                                    <span v-if="char === 'Hohlschnitt'">eingenähtes Gurtband, D-Ring</span>
                                  </span>
                                </li>
                              </ul>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" xl="2" class="font-weight-bold text-xl-right pl-xl-0">{{cart.table.article.note}}</b-col>
                            <b-col cols="12" xl="10">
                              <div class="mb-1">{{configuration.note === '' ? '&ndash;' : configuration.note}}</div>
                              <div v-if="configuration.oesenTotal > 0">Gesamt: {{configuration.oesenTotal}} Ösen{{configuration.drehverschluss ? ' inkl. Drehverschlüsse' : ''}}</div>
                              <div v-if="configuration.hohlsaum">Hohlsaum flach gemessen</div>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                  <b-col class="d-md-none text-right" :class="{'d-none': xs}" cols="1">
                    <a @click="removeConfig(index)" style="cursor:pointer;">
                      <b-icon-trash class="kub-color-red" v-b-tooltip.hover :title="cart.tipDelete"></b-icon-trash>
                    </a>
                  </b-col>
                </b-row>
              </b-card>
            </b-td>
            <b-td :class="[{'kub-padding-count': md}, {'kub-no-border': !md}]">
              <b-row class="align-items-center">
                <b-col class="pr-0 d-md-none">
                  <div class="align-self-center text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.quantity}}</div>
                </b-col>
                <b-col>
                  <b-form-spinbutton v-model="configuration.quantity" min="1" max="100" inline class="float-right"></b-form-spinbutton>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-row>
                <b-col class="d-md-none">
                  <div class="text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.unitPrice}}</div>
                </b-col>
                <b-col>
                  <div class="float-right">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(getUnitPrice(configuration))}}</div>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'kub-no-border': !md}">
              <b-row>
                <b-col class="d-md-none">
                  <div class="text-uppercase font-weight-bold float-left kub-color">{{cart.table.headings.sumPrice}}</div>
                </b-col>
                <b-col>
                  <div class="float-right font-weight-bold">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(getSumPrice(configuration))}}</div>
                </b-col>
              </b-row>
            </b-td>
            <b-td :class="{'d-none': !md}">
              <a @click="removeConfig(index)" style="cursor:pointer;" class="float-right">
                <b-icon-trash class="kub-color-red" v-b-tooltip.hover :title="cart.tipDelete"></b-icon-trash>
              </a>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-row class="py-3 mb-4 kub-shoppingCart-summary rounded">
        <b-col cols="12" offset-md="6" md="6">
          <ul class="p-0" style="list-style:none;">
            <li>
              <div class="w-50 float-left text-left">
                <span class="font-weight-bold text-uppercase">{{cart.summary.sum}}</span> <span>{{cart.summary.vatBefore}} {{checkVAT ? '0%' : ''}} {{cart.summary.vatAfter}}</span>
              </div>
              <div class="w-50 float-right text-right font-weight-bold">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcSumPriceVAT)}}</div>
            </li>
          </ul>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pr-0" :class="{'pl-0': !lg}" col offset-lg="6" lg="3">
          <b-button type="submit" href="#" block variant="link" :class="[{'kub-btn': true}, {'text-decoration-none': true}, {'mb-2': xs}]" @click="newConfig(), changeView({x: 0, y: 0})">
            <b-icon icon="plus" font-scale="1"></b-icon>
            <span id="kub-cart-add-text" class="ml-1">Neue Plane</span>
            <span id="kub-cart-add-textShort" class="ml-1">Neu</span>
          </b-button>
        </b-col>
        <b-col class="pr-0" col lg="3">
          <b-button type="submit" href="#" v-b-toggle="summaryComponents.address.toggle" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" :disabled="configurationList.length === 0" @click="changeStatusShoppingCart(), addQuantity(configurationList), changeView({x: 0, y: 0})">
            <span class="ml-auto mr-auto">Weiter</span>
            <b-icon icon="chevron-right" font-scale="0.95"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import cartDreieckGS from './forms/cartDreieckGS.vue'
import cartDreieckGSE from './forms/cartDreieckGSE.vue'
import cartDreieckRW from './forms/cartDreieckRW.vue'
import cartHalbkreis from './forms/cartHalbkreis.vue'
import cartHeptagon from './forms/cartHeptagon.vue'
import cartHexagon from './forms/cartHexagon.vue'
import cartKreis from './forms/cartKreis.vue'
import cartOktagon from './forms/cartOktagon.vue'
import cartPentagon from './forms/cartPentagon.vue'
import cartRechteck from './forms/cartRechteck.vue'
import cartTrapezGS from './forms/cartTrapezGS.vue'
import cartTrapezSSR from './forms/cartTrapezSSR.vue'
import cartTrapezSSL from './forms/cartTrapezSSL.vue'
import cartTrapezSOR from './forms/cartTrapezSOR.vue'
import cartTrapezSOL from './forms/cartTrapezSOL.vue'
import cartTrapezSER from './forms/cartTrapezSER.vue'
import cartTrapezSEL from './forms/cartTrapezSEL.vue'

import DataSummary from '../../../../data/main/summary/summary'
import DataForms from '../../../../data/main/config/setup/form/forms'
import DataMaterials from '../../../../data/main/config/setup/material/materials'
import DataSetup from '../../../../data/main/config/setup/setup'
import DataCart from '../../../../data/main/summary/cart/cart'
import DataService from './../../../../services/DataService'
import { a, b, c, d, h } from '../../../../data/main/config/setup/form/sides'

import { mapGetters, mapActions } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

const { mapMultiRowFields } = createHelpers({
  getterType: 'getConfigurationField',
  mutationType: 'updateConfigurationField'
})

export default {
  data () {
    return {
      summaryComponents: DataSummary.components,
      forms: DataForms.forms,
      materials: DataMaterials.materials,
      setupComponents: DataSetup.components,
      cart: DataCart.cart,
      sides: [a.title, b.title, c.title, d.title, h.title],
      VAT: null,
      basicsLoaded: false
    }
  },
  components: {
    cartDreieckGS,
    cartDreieckGSE,
    cartDreieckRW,
    cartHalbkreis,
    cartHeptagon,
    cartHexagon,
    cartKreis,
    cartOktagon,
    cartPentagon,
    cartRechteck,
    cartTrapezGS,
    cartTrapezSSR,
    cartTrapezSSL,
    cartTrapezSOR,
    cartTrapezSOL,
    cartTrapezSER,
    cartTrapezSEL
  },
  methods: {
    ...mapActions([
      'decreaseTabIndex',
      'clearForm',
      'clearMaterial',
      'clearRandSides',
      'setRandSides',
      'clearSetup',
      'changeStatusShoppingCart',
      'removeConfiguration',
      'removeConfObj',
      'setDraftFormType',
      'addQuantity',
      'changeView',
      'clearConfigNote',
      'clearConfigPrice',
      'clearConfigOesenTotal',
      'clearCalc',
      'setCalcInitial',
      'basicsLoadingError',
      'resetFormSelected'
    ]),
    newConfig () {
      if (this.formComplete) {
        this.$root.$emit('bv::toggle::collapse', this.setupComponents.form.toggle)
      }
      if (this.materialType !== this.materials.pvc600.type) {
        this.$root.$emit('bv::toggle::collapse', this.materials.pvc600.images.toggle)
      }
      this.clearConfigNote()
      this.clearConfigPrice()
      this.clearConfigOesenTotal()
      this.clearRandSides()
      this.setRandSides(this.forms.rechteck.type[0].rand)
      this.clearMaterial()
      this.clearForm()
      this.resetFormSelected()
      this.clearSetup()
      this.decreaseTabIndex()
      this.setDraftFormType(this.forms.rechteck.type[0].draftFormType)
      this.clearCalc()
    },
    removeConfig (index) {
      this.removeConfiguration(index)
      this.removeConfObj(index)
    },
    roundToTwo (value) {
      return Math.round((value + Number.EPSILON) * 100) / 100
    },
    getUnitPrice (configuration) {
      if (this.checkVAT) {
        return this.roundToTwo(configuration.price / (1 + this.VATRate))
      }
      return this.roundToTwo(configuration.price)
    },
    getSumPrice (configuration) {
      const unitPrice = this.getUnitPrice(configuration)
      return this.roundToTwo(unitPrice * configuration.quantity)
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'formComplete',
      'materialType',
      'calcSumPriceVAT',
      'activeOesenArt',
      'calcOesenAnzahlTotal',
      'checkVAT',
      'VATRate'
    ]),
    ...mapMultiRowFields([
      'configurationList'
    ])
  },
  async created () {
    try {
      const basics = await DataService.getBasics()
      const initValues = await DataService.getInitialValues()
      this.VAT = basics.B02.value
      const minOrder = basics.B01.value
      this.setCalcInitial({
        minOrder,
        formFactor: initValues.formFactor,
        materialPrice: initValues.materialPrice,
        deliveryTime: initValues.deliveryTime
      })
      this.basicsLoaded = true
    } catch (err) {
      this.basicsLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
  .card {
    min-width: 100%;
    margin-bottom: 1rem;
  }

  .kub-shoppingCart-summary {
    border: 1px solid #dee2e6;
    background-color: #f4f6f6;
  }

  .kub-padding-count {
    padding-top: 25px !important;
  }

  .kub-cart-img {
    width: 100% !important;
    height: auto !important;
    min-width: 120px;
    min-height: 120px;
    max-width: 200px;
    max-height: 200px;
  }

  ul > li > div.float-left {
    padding-left: 12px;
  }

  ul > li > div.float-right {
    padding-right: 12px;
  }

  .card-header {
    border-bottom: none;
  }

  td {
    padding-top: 32px !important;
  }

  #kub-cart-add-textShort {
    display: none;
  }

  @media (max-width: 360px) {
    #kub-cart-add-text {
      display: none;
    }
    #kub-cart-add-textShort {
      display: inline;
    }
  }

  @media (max-width: 575px) {
    .kub-cart-img {
      width: 120px !important;
      height: 120px !important;
      margin-bottom: 1rem;
      display: inline-block;
    }
  }

  @media (max-width: 767px) {
    td {
      padding-top: 12px !important;
    }
  }
</style>
